import { config } from 'data';
import { profileService } from 'services';
import { useQuery } from 'hooks';

const useProfileQuery = () => useQuery({
  queryKey: [config.PROFILE_QUERY_KEY],
  queryFn: () => profileService.getProfile(),
});

export default useProfileQuery;
